module.exports = __webpack_public_path__ + "static/media/elixir-gifts-img-1.b6476a49.jpg";